import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_26c5057c from 'nuxt_plugin_plugin_26c5057c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_3d240187 from 'nuxt_plugin_bootstrapvue_3d240187' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_recaptcha_c441c472 from 'nuxt_plugin_recaptcha_c441c472' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_2e27b82e from 'nuxt_plugin_gtm_2e27b82e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_httpclient_e745290c from 'nuxt_plugin_httpclient_e745290c' // Source: ../plugins/http-client (mode: 'all')
import nuxt_plugin_eventinsightsalgolia_09c5cd28 from 'nuxt_plugin_eventinsightsalgolia_09c5cd28' // Source: ../plugins/event-insights-algolia (mode: 'all')
import nuxt_plugin_bootstrapvue_928a4c1e from 'nuxt_plugin_bootstrapvue_928a4c1e' // Source: ../plugins/bootstrap-vue (mode: 'all')
import nuxt_plugin_router_3e5c7b82 from 'nuxt_plugin_router_3e5c7b82' // Source: ../plugins/router (mode: 'all')
import nuxt_plugin_eventbus_719ef217 from 'nuxt_plugin_eventbus_719ef217' // Source: ../plugins/event-bus (mode: 'all')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a' // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_authenprovider_4eeb0c5d from 'nuxt_plugin_authenprovider_4eeb0c5d' // Source: ../plugins/service/authen-provider (mode: 'all')
import nuxt_plugin_profileprovider_661bf9b6 from 'nuxt_plugin_profileprovider_661bf9b6' // Source: ../plugins/service/profile-provider (mode: 'all')
import nuxt_plugin_shoppingcartprovider_06b827e9 from 'nuxt_plugin_shoppingcartprovider_06b827e9' // Source: ../plugins/service/shopping-cart-provider (mode: 'all')
import nuxt_plugin_productprovider_60830e9f from 'nuxt_plugin_productprovider_60830e9f' // Source: ../plugins/service/product-provider (mode: 'all')
import nuxt_plugin_productnotifymeprovider_2e4652af from 'nuxt_plugin_productnotifymeprovider_2e4652af' // Source: ../plugins/service/product-notifyme-provider (mode: 'all')
import nuxt_plugin_logisticprovider_203a3f2e from 'nuxt_plugin_logisticprovider_203a3f2e' // Source: ../plugins/service/logistic-provider (mode: 'all')
import nuxt_plugin_bannerprovider_6bb033e2 from 'nuxt_plugin_bannerprovider_6bb033e2' // Source: ../plugins/service/banner-provider (mode: 'all')
import nuxt_plugin_orderprovider_0dfc99c0 from 'nuxt_plugin_orderprovider_0dfc99c0' // Source: ../plugins/service/order-provider (mode: 'all')
import nuxt_plugin_core_7535bd2f from 'nuxt_plugin_core_7535bd2f' // Source: ../plugins/service/core (mode: 'all')
import nuxt_plugin_graphQL_9f0e0f4e from 'nuxt_plugin_graphQL_9f0e0f4e' // Source: ../plugins/service/graphQL (mode: 'all')
import nuxt_plugin_filter_68021324 from 'nuxt_plugin_filter_68021324' // Source: ../plugins/filter (mode: 'all')
import nuxt_plugin_submit_3a5b29e4 from 'nuxt_plugin_submit_3a5b29e4' // Source: ../plugins/submit (mode: 'all')
import nuxt_plugin_extendrule_d642cece from 'nuxt_plugin_extendrule_d642cece' // Source: ../plugins/extend-rule (mode: 'all')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'all')
import nuxt_plugin_clickoutside_5b0e370d from 'nuxt_plugin_clickoutside_5b0e370d' // Source: ../plugins/click-outside.js (mode: 'all')
import nuxt_plugin_vuemultiselect_7aa8df7f from 'nuxt_plugin_vuemultiselect_7aa8df7f' // Source: ../plugins/vue-multiselect.js (mode: 'all')
import nuxt_plugin_vue2googlemaps_94a82780 from 'nuxt_plugin_vue2googlemaps_94a82780' // Source: ../plugins/vue2-google-maps (mode: 'client')
import nuxt_plugin_encryption_3032cf79 from 'nuxt_plugin_encryption_3032cf79' // Source: ../plugins/encryption (mode: 'all')
import nuxt_plugin_useragent_b14e830e from 'nuxt_plugin_useragent_b14e830e' // Source: ../plugins/user-agent (mode: 'client')
import nuxt_plugin_clickbanner_198bf587 from 'nuxt_plugin_clickbanner_198bf587' // Source: ../plugins/click-banner (mode: 'client')
import nuxt_plugin_directusprovider_04d4ddb2 from 'nuxt_plugin_directusprovider_04d4ddb2' // Source: ../plugins/service/directus-provider (mode: 'all')
import nuxt_plugin_braze_1b867e1e from 'nuxt_plugin_braze_1b867e1e' // Source: ../plugins/braze.js (mode: 'client')
import nuxt_plugin_graphqlprovider_649660e5 from 'nuxt_plugin_graphqlprovider_649660e5' // Source: ../plugins/service/graphql-provider (mode: 'all')
import nuxt_plugin_history_1e0f185e from 'nuxt_plugin_history_1e0f185e' // Source: ../plugins/history (mode: 'all')
import nuxt_plugin_separate_40bec899 from 'nuxt_plugin_separate_40bec899' // Source: ../plugins/separate (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"th"},"title":"OFM Biz มีครบ จบไว สั่งง่าย ได้เร็ว","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, height=device-height, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0, shrink-to-fit=no"},{"hid":"facebook-domain-verification","name":"facebook-domain-verification","content":"52ptcbbylj6n1716vp317ojaj3s4es"}],"script":[{"hid":"crm-object","src":"https:\u002F\u002Fofm-cdn0.ofm.co.th\u002Fjs\u002Flive-chat.js?v=20250616090152","type":"text\u002Fjavascript","async":true,"defer":false},{"type":"application\u002Fld+json","json":{"@context":"http:\u002F\u002Fschema.org","@type":"Organization","url":"https:\u002F\u002Fwww.officemate.co.th\u002F","logo":"https:\u002F\u002Fwww.ofm.co.th\u002F_nuxt\u002Fimg\u002Flogo.629314a.png","address":{"@type":"PostalAddress","addressLocality":"กรุงเทพมหานคร","postalCode":"10500","streetAddress":"เลขที่ 919\u002F555 อาคารเซาท์ทาวเวอร์ ชั้น 14 ห้อง 2-6 และ 9 ถนนสีลม แขวงสีลม เขตบางรัก"},"email":"contact@officemate.co.th","faxNumber":"02-763-5555","name":"บริษัท ออฟฟิศเมท (ไทย) จำกัด สำนักงานใหญ่","telephone":"1281"}},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TVKQ5LW')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavico.png"},{"rel":"preconnect","crossorigin":"anonymous","href":"https:\u002F\u002Fwww.googletagmanager.com\u002F"},{"rel":"preconnect","crossorigin":"anonymous","href":"https:\u002F\u002Fwww.google-analytics.com"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TVKQ5LW&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_26c5057c === 'function') {
    await nuxt_plugin_plugin_26c5057c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_3d240187 === 'function') {
    await nuxt_plugin_bootstrapvue_3d240187(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_c441c472 === 'function') {
    await nuxt_plugin_recaptcha_c441c472(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2e27b82e === 'function') {
    await nuxt_plugin_gtm_2e27b82e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (typeof nuxt_plugin_httpclient_e745290c === 'function') {
    await nuxt_plugin_httpclient_e745290c(app.context, inject)
  }

  if (typeof nuxt_plugin_eventinsightsalgolia_09c5cd28 === 'function') {
    await nuxt_plugin_eventinsightsalgolia_09c5cd28(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_928a4c1e === 'function') {
    await nuxt_plugin_bootstrapvue_928a4c1e(app.context, inject)
  }

  if (typeof nuxt_plugin_router_3e5c7b82 === 'function') {
    await nuxt_plugin_router_3e5c7b82(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_719ef217 === 'function') {
    await nuxt_plugin_eventbus_719ef217(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3336a20a === 'function') {
    await nuxt_plugin_utils_3336a20a(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_authenprovider_4eeb0c5d === 'function') {
    await nuxt_plugin_authenprovider_4eeb0c5d(app.context, inject)
  }

  if (typeof nuxt_plugin_profileprovider_661bf9b6 === 'function') {
    await nuxt_plugin_profileprovider_661bf9b6(app.context, inject)
  }

  if (typeof nuxt_plugin_shoppingcartprovider_06b827e9 === 'function') {
    await nuxt_plugin_shoppingcartprovider_06b827e9(app.context, inject)
  }

  if (typeof nuxt_plugin_productprovider_60830e9f === 'function') {
    await nuxt_plugin_productprovider_60830e9f(app.context, inject)
  }

  if (typeof nuxt_plugin_productnotifymeprovider_2e4652af === 'function') {
    await nuxt_plugin_productnotifymeprovider_2e4652af(app.context, inject)
  }

  if (typeof nuxt_plugin_logisticprovider_203a3f2e === 'function') {
    await nuxt_plugin_logisticprovider_203a3f2e(app.context, inject)
  }

  if (typeof nuxt_plugin_bannerprovider_6bb033e2 === 'function') {
    await nuxt_plugin_bannerprovider_6bb033e2(app.context, inject)
  }

  if (typeof nuxt_plugin_orderprovider_0dfc99c0 === 'function') {
    await nuxt_plugin_orderprovider_0dfc99c0(app.context, inject)
  }

  if (typeof nuxt_plugin_core_7535bd2f === 'function') {
    await nuxt_plugin_core_7535bd2f(app.context, inject)
  }

  if (typeof nuxt_plugin_graphQL_9f0e0f4e === 'function') {
    await nuxt_plugin_graphQL_9f0e0f4e(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_68021324 === 'function') {
    await nuxt_plugin_filter_68021324(app.context, inject)
  }

  if (typeof nuxt_plugin_submit_3a5b29e4 === 'function') {
    await nuxt_plugin_submit_3a5b29e4(app.context, inject)
  }

  if (typeof nuxt_plugin_extendrule_d642cece === 'function') {
    await nuxt_plugin_extendrule_d642cece(app.context, inject)
  }

  if (typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_5b0e370d === 'function') {
    await nuxt_plugin_clickoutside_5b0e370d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_7aa8df7f === 'function') {
    await nuxt_plugin_vuemultiselect_7aa8df7f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2googlemaps_94a82780 === 'function') {
    await nuxt_plugin_vue2googlemaps_94a82780(app.context, inject)
  }

  if (typeof nuxt_plugin_encryption_3032cf79 === 'function') {
    await nuxt_plugin_encryption_3032cf79(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_useragent_b14e830e === 'function') {
    await nuxt_plugin_useragent_b14e830e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickbanner_198bf587 === 'function') {
    await nuxt_plugin_clickbanner_198bf587(app.context, inject)
  }

  if (typeof nuxt_plugin_directusprovider_04d4ddb2 === 'function') {
    await nuxt_plugin_directusprovider_04d4ddb2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_braze_1b867e1e === 'function') {
    await nuxt_plugin_braze_1b867e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_graphqlprovider_649660e5 === 'function') {
    await nuxt_plugin_graphqlprovider_649660e5(app.context, inject)
  }

  if (typeof nuxt_plugin_history_1e0f185e === 'function') {
    await nuxt_plugin_history_1e0f185e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_separate_40bec899 === 'function') {
    await nuxt_plugin_separate_40bec899(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
